<template lang="html">
  <div>
    <header class="live__header__desktop">
      <v-layout wrap>
        <v-flex md6 xs6 class="live__header__desktop--logo">
          <img src="https://liveb2itest.id.dyned.com/assets/images/logo.png" height="35px;" alt="">
        </v-flex>
        <div style="width:50%;" v-if="!myData">
          <content-loader
            :height="100"
            :width="500"
            :speed="2"
            primaryColor="#e6e6e6"
            secondaryColor="#d2d2d2"
          >
            <rect x="286.63" y="44.61" rx="0" ry="0" width="0" height="0" />
        		<rect x="416.63" y="216.61" rx="0" ry="0" width="0" height="0" />
        		<rect x="309.63" y="40.61" rx="0" ry="0" width="79.04" height="9.41" />
        		<circle cx="426.79" cy="51.87" r="13.16" />
        		<rect x="309.63" y="51.61" rx="0" ry="0" width="98.36" height="10.82" />
        		<circle cx="270.08" cy="51.16" r="13.5" />
          </content-loader>
        </div>
        <v-flex md6 xs6 class="live__header__desktop--account"  v-if="myData">
          <div class="live__header__desktop--notif">
            <v-menu
              bottom
              left
              >
              <v-btn
                slot="activator"
                icon
              >
                <v-badge color="#f34949">
                  <span slot="badge">8</span>
                  <v-icon color="#6c6c6c">notifications</v-icon>
                </v-badge>
              </v-btn>

              <div class="notification__title">
                <h5>Notifications</h5>
              </div>
              <v-list-tile
                v-for="(item, i) in notifications"
                :key="i"
                avatar
                style="background:#fafafa;"
              >
                <v-list-tile-avatar>
                  <img :src="item.avatar">
                </v-list-tile-avatar>

                <v-list-tile-content>
                  <v-list-tile-title v-html="item.notif"></v-list-tile-title>
                </v-list-tile-content>

                <!-- <v-list-tile-action>
                  <v-icon :color="item.active ? 'teal' : 'grey'">chat_bubble</v-icon>
                </v-list-tile-action> -->
              </v-list-tile>
              <div class="notification__title justify-center">
                <router-link to="#">See All</router-link>
              </div>
            </v-menu>
          </div>
          <div class="live__header__desktop--account--info  hidden-sm-and-down">
            <h4>{{ this.GET_AdditionaLinfo.fullname }}</h4>
            <h5>{{ this.GET_AdditionaLinfo.username }}</h5>
          </div>
          <div class="live__header__desktop--account--thumb">
            <router-link to="/coach/profile">
              <v-avatar
                size="32"
                color="grey lighten-4"
              >
               <img :src='GET_AdditionaLinfo.avatar' alt="avatar">
            </v-avatar>
            </router-link>
          </div>
          <div class="live__header__desktop--menu  hidden-sm-and-down">
            <v-layout row>
                <v-menu
                  bottom
                  left
                  >
                  <v-btn
                    slot="activator"
                    icon
                  >
                    <v-icon>more_horiz</v-icon>
                  </v-btn>

                  <v-list-tile
                    style="background:#fafafa;"
                    class="live__header__desktop--list"
                  >
                    <v-list-tile-title>Profile</v-list-tile-title>
                    <v-list-tile-title><router-link to="/coach/settings">Account Setting</router-link></v-list-tile-title>
                    <v-list-tile-title @click="onLogout">Logout</v-list-tile-title>
                  </v-list-tile>
                </v-menu>
            </v-layout>
          </div>
        </v-flex>
      </v-layout>
    </header>
  </div>
</template>

<script>
import { ContentLoader } from 'vue-content-loader';

export default {
  components: {
    ContentLoader
  },
  data () {
    return {
      myData: null,
      notifications: [
        {
          notif: 'New session booked with Andy Shakespear',
          avatar: '/static/img/dualipa.aa0d764.jpg'
        },
        {
          notif: 'New session booked with Ani Susetyo',
          avatar: '/static/img/dualipa.aa0d764.jpg'
        },
        {
          notif: 'New session booked with Brandon Burges',
          avatar: '/static/img/dualipa.aa0d764.jpg'
        },
        {
          notif: 'New session booked with Fajrudin Malik',
          avatar: '/static/img/dualipa.aa0d764.jpg'
        },
        {
          notif: 'New session booked with Ahmad Sungkar',
          avatar: '/static/img/dualipa.aa0d764.jpg'
        }
      ]
    }
  },
  methods: {
    onLogout() {
      this.$store.dispatch('LOGOUT')
    }
  },
  mounted() {
    // Just pretend this is an AJAX call. Use your imagination.
    setTimeout(() => {
      this.myData = 'Example Data';
    }, 100);
  },
  computed: {
    GET_AdditionaLinfo(){
			return this.$store.state.DataAdditional
    }
  },
  created() {
   this.$store.dispatch("GET_PROFILEADDITIONAL");
  },
  watch: {
    GET_AdditionaLinfo(val){
      if (!val) return

      this.myData = null
      setTimeout(() =>
         this.myData = 'example',
      2000)
    }
  },
}
</script>

<style lang="scss">
  // @import '../../views/content/Header.scss';
  // .v-list__tile__title {
  //   cursor: pointer;
  // }
  // a{
  //   text-decoration: none;
  //   color: $fontBlack;
  // }
</style>



// WEBPACK FOOTER //
// src/coach-components/CoachLayout/CoachHeader.vue